import gql from 'graphql-tag'

export default gql`
  mutation requestPriceSuggestion(
    $address: AddressInput!
    $area: Int!
    $bathrooms: Int!
    $garageSpots: Int!
    $rooms: Int!
    $suites: Int
    $maintenanceFee: Float
    $type: String
    $isCovered: Boolean!
  ) {
    requestPriceSuggestion(
      address: $address
      area: $area
      bathrooms: $bathrooms
      garageSpots: $garageSpots
      rooms: $rooms
      suites: $suites
      maintenanceFee: $maintenanceFee
      type: $type
      isCovered: $isCovered
    ) {
      id
      suggestedPrice
      listingAveragePricePerSqrMeter
      listingPriceErrorQ90Max
      listingPriceErrorQ90Min
      listingPricePerSqrMeter
    }
  }
`
